import React, { PropsWithChildren } from 'react';
import { SummarySection } from '@ydistri/ds';

interface StoreEvaluationSummarySubSectionProps extends PropsWithChildren {
  title: string;
  loading?: boolean;
  minWidth?: string;
}

/**
 * Displays a subsection in the store evaluation summary with a title.
 * It is used to group related information under a common title.
 */
const StoreEvaluationSummarySubSection: React.FC<StoreEvaluationSummarySubSectionProps> = ({
  title,
  children,
  loading = false,
  minWidth = '376px',
}) => {
  return (
    <SummarySection title={title} loading={loading} $minWidth={minWidth}>
      {children}
    </SummarySection>
  );
};

export default StoreEvaluationSummarySubSection;
